import API from "./api";

/**
 * Persist an explicit "salary structures configured" flag (same pattern as
 * components_completed / settings_completed).
 */
export async function markSalaryStructuresConfigured() {
  const savedAt = new Date().toISOString();
  try {
    const res = await API.get("/organisation/me/hr-settings");
    const hr = res?.data?.hr_settings || {};
    const payroll = { ...(hr.payroll || {}) };
    if (payroll.structures_completed === true && payroll.structures_saved_at) {
      return payroll;
    }
    await API.patch("/organisation/me/hr-settings", {
      payroll: {
        ...payroll,
        structures_completed: true,
        structures_saved_at: savedAt,
      },
    });
    return { ...payroll, structures_completed: true, structures_saved_at: savedAt };
  } catch {
    return null;
  }
}
